import type { SolutionSector } from "../sectors";
import { ASK_LINE, CHECK_LINE, LOGO } from "./shared";

export const CREATIVE_MEDIA: SolutionSector = {
  slug: "creative-media",
  name: "Creative & media",
  demoOrg: "Demo (Creative + Media)",
  story: "creative",
  metadata: {
    title: "AI for production readiness in creative studios | Your Twin",
    description:
      "See which jobs have open decisions or supplier queries before production starts. Your Twin connects Google Drive, Google Sheets, Xero and Slack.",
  },
  hero: {
    label: "Creative & media",
    title: ["Know what’s", "still open", "before the shoot."],
    lead: [
      "Spend less time chasing production details. Your Twin connects briefs in ",
      LOGO.drive,
      ", trackers in ",
      LOGO.sheets,
      ", supplier bills in ",
      LOGO.xero,
      " and conversations in ",
      LOGO.slack,
      ", so you can see which jobs have open decisions or supplier queries before production starts.",
    ],
    cta: "Bring a production handover",
    buyer: "For studio founders, heads of production and executive producers",
    instrumentLabel: "The production Twin · Job, brief, supplier and producer",
    legendLines: [
      "Read Google Drive, Google Sheets, Xero and Slack.",
      "Link each job to its brief, schedule, suppliers and client changes.",
      "Build one picture of each job before it starts.",
      CHECK_LINE,
      "Have agents prepare production reviews and flag open details.",
      "Save their work in shared channels: job trackers and review tables.",
      ASK_LINE,
    ],
  },
  replay: {
    title: "What’s still open\nbefore next week?",
    lead: "Ask across the briefs, the tracker, supplier bills and the client’s messages. See each open detail beside its start date and producer.",
  },
  outcomes: {
    title: "A clear handover\nbefore the crew arrives.",
    lead: "Producers see what is decided, what is still open and who owns it, from the records your studio already keeps.",
    items: [
      { title: "Find the missing detail.", body: "Check the brief and the production tracker together.", show: "status" },
      { title: "Bring supplier questions forward.", body: "See unresolved queries before the work starts.", show: "sources" },
      { title: "Keep the decision with production.", body: "Give the producer the evidence behind each open point.", show: "owners" },
    ],
  },
  start: { firstStep: "Choose a production handover that takes too much chasing." },
  questions: [
    { q: "Does it review creative quality?", a: "No. This workflow checks recorded details and decisions. Creative judgement stays with your team and your client." },
    { q: "Will it organise or version our media assets?", a: "Keep your existing asset tools. This example reads connected documents and records; it isn’t a media asset management system." },
    { q: "Can it compare a brief with a quantity schedule?", a: "Where the formats can be read and matched reliably. We test your own examples before making it part of the workflow." },
  ],
  closing: "Start with one production handover\nthat takes too much chasing.",
};
